// Constants shared across the app and the service worker.

// -- Caches (service worker <-> page handoff) --

// Cache holding the app shell for offline use. Bump the version to invalidate.
export const SHELL_CACHE = "tally-shell-v1";

// Cache used to pass a shared image from the service worker to the page.
export const SHARE_CACHE = "tally-share";

// Fixed cache URL the shared image is stashed under.
export const SHARED_URL = "/__shared-image";

// -- OCR tuning --

// Upscale crops so the long edge is at least this; Tesseract prefers big glyphs.
export const MIN_LONG_EDGE = 1400;

// Downscale photos so the long edge is at most this. Full-resolution phone photos
// leave dot-matrix print as disjoint dots, which Tesseract misreads; shrinking
// fuses the dots into solid strokes.
export const MAX_LONG_EDGE = 2000;

// Tesseract language packs to load. Data is fetched from the CDN on first use.
export const OCR_LANGS = "eng";
